import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Tow } from '@models/tow.model';

export const adapter: EntityAdapter<Tow> = createEntityAdapter<Tow>({
    selectId: tow => tow.id
});

export interface State extends EntityState<Tow> {
    loading: boolean;
    error?: any;
    total: number;
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    error: null,
    total: 0
});
